/**
 * Formats milliseconds to a human-readable time string (HH:MM:SS)
 */
export function formatTimeFromMs(milliseconds: number): string {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Format as HH:MM:SS
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

/**
 * Get just the formatted time part for display
 */
export function getFormattedNextTime(nextGeneration: number): string {
  return formatTimeFromMs(nextGeneration);
}
